import { useTranslation } from "react-i18next";
import curiosidadeImg from "../../../assets/cajuCultura.jpg";

export default function Curiosidade() {
  const { t } = useTranslation();
  return (
    <section id="curiosidade-sobreNos" className="curiosidade">
      <h1>{t("nos.curiosidade.titulo")}</h1>
      <div className="curiosidade-container">
        <p>
          {t("nos.curiosidade.descricao.p1")}
          <br />
          {t("nos.curiosidade.descricao.p2")}
          <br />
          {t("nos.curiosidade.descricao.p3")}
          <br />
          {t("nos.curiosidade.descricao.p4")}
        </p>
        <img src={curiosidadeImg} alt="Mapa Mundi" />
      </div>
    </section>
  );
}
